import { Spin } from "antd5";
import classNames from "classnames";

import { getDocumentViewerSource } from "components/documents/utils";
import Button from "components/ui/button/Button";
import FileViewer from "lib/core_components/FileViewer";

import css from "./PdfViewerContainer.module.scss";

import FOLDER from "../../../assets/images/folder.svg";

export function PdfViewerContainer({
  pdfDocumentUrl,
  downloadUrl,
  originalMimeType,
  isLoading,
  hasKeywordsFilter,
  containerClassName,
  inDrawer = false,
}: {
  pdfDocumentUrl: string;
  downloadUrl: string;
  originalMimeType?: string | null;
  isLoading?: boolean;
  hasKeywordsFilter: boolean;
  containerClassName?: string;
  inDrawer?: boolean;
}) {
  const source = getDocumentViewerSource(pdfDocumentUrl, downloadUrl, originalMimeType);
  const cannotPreview = !source;

  const unsupportedDocument = (
    <>
      <div className={classNames(css.container, containerClassName)}>
        {hasKeywordsFilter ? (
          <>
            <img src={FOLDER} alt="Folder" className={css.folderImg} />
            <h2>We are unable to preview this document</h2>
            <p className={css.info}>
              This document matches your search but we can't show a preview of this file type.
              Download the document to view its content.
            </p>
          </>
        ) : (
          <>
            <img src={FOLDER} alt="Folder" className={css.folderImg} />
            <h2>Unsupported document type</h2>
            <p className={css.info}>
              We are unable to display this document type in app. Please download the document to
              view it.
            </p>
          </>
        )}
        <Button as="a" download href={downloadUrl} icon="download01" className={css.download}>
          Download to view
        </Button>
      </div>
    </>
  );

  if (!inDrawer && isLoading) {
    return <Spin className={css.container} />;
  }

  if (!inDrawer && cannotPreview) {
    return unsupportedDocument;
  }

  return (
    <>
      {(isLoading || cannotPreview) && (
        <div className={css.overlay}>
          {isLoading && <Spin className={css.container} />}
          {!isLoading && cannotPreview && unsupportedDocument}
        </div>
      )}
      <FileViewer
        documentUrl={source?.url ?? ""}
        fileExtension={source?.extension}
        // Annotations are enabled for AI search results
        enableAnnotations={true}
        disabledElements={[
          "header",
          "toolsHeader",
          "textPopup",
          "contextMenuPopup",
          "searchPanel",
          "printModal",
          "errorModal",
        ]}
      />
    </>
  );
}
